const TwitterLogo = ({
  ...props
}: React.SVGAttributes<SVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 30 30'
    width='1em'
    {...props}
  >
    <path d='M29.15 8.05a.62.62 0 0 0 .08-.88.61.61 0 0 0-.33-.17l-1-.25a.62.62 0 0 1-.44-.75.36.36 0 0 1 0-.11l.55-1.11a.63.63 0 0 0-.29-.84.64.64 0 0 0-.43 0l-2.5.7a.6.6 0 0 1-.55-.1 6.25 6.25 0 0 0-10 5v.36a.31.31 0 0 1-.28.31c-3.51.42-6.88-1.37-10.5-5.55a.66.66 0 0 0-.64-.19.64.64 0 0 0-.32.53 9.44 9.44 0 0 0 .58 6.15.33.33 0 0 1-.14.42.32.32 0 0 1-.19 0l-1.4-.27a.62.62 0 0 0-.72.51.54.54 0 0 0 0 .22 6.46 6.46 0 0 0 3 4.73.31.31 0 0 1 .15.41.36.36 0 0 1-.15.15l-.66.26a.63.63 0 0 0-.35.82 5.48 5.48 0 0 0 4 3.11.31.31 0 0 1 0 .58 13.51 13.51 0 0 1-5.36 1A.64.64 0 1 0 1 24.45a25.06 25.06 0 0 0 10.18 2.41 15.71 15.71 0 0 0 8.75-2.5 15.6 15.6 0 0 0 6.94-13v-1.12a.67.67 0 0 1 .23-.48Z' />
  </svg>
)

export default TwitterLogo
